var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "mesage-center"
  }, [_c("a-form", {
    staticStyle: {
      "margin-bottom": "20px",
      width: "100%"
    },
    attrs: {
      layout: "inline"
    }
  }, [_c("a-form-item", [_c("div", {
    staticClass: "btns",
    class: _vm.messageCenterTab == "all" ? "left" : "",
    staticStyle: {
      display: "flex"
    }
  }, [_c("div", {
    staticClass: "btn",
    class: _vm.messageCenterTab == "all" ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.changeTab("all");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("全部消息")) + " ")]), _c("div", {
    staticClass: "btn",
    class: _vm.messageCenterTab == "unRead" ? "hit" : "",
    on: {
      click: function ($event) {
        return _vm.changeTab("unRead");
      }
    }
  }, [_c("a-badge", {
    attrs: {
      count: _vm.unReadCount
    }
  }, [_c("div", {
    staticStyle: {
      height: "40px",
      display: "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("未读消息")) + " ")])])], 1)])])], 1), _c("div", {
    staticStyle: {
      "text-align": "right",
      "margin-bottom": "10px"
    }
  }, [_c("a-button", {
    on: {
      click: _vm.allRead
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("全部已读")) + " ")])], 1), _vm.messageCenterList.length === 0 ? _c("div", {
    staticClass: "empty-list"
  }, [_c("svg-icon", {
    staticStyle: {
      "margin-top": "10px",
      "flex-basis": "100%"
    },
    attrs: {
      icon: "emptyData",
      size: 50
    }
  }), _c("p", [_vm._v(_vm._s(_vm.$t("暂无数据")))])], 1) : _c("div", {
    staticClass: "message-list"
  }, _vm._l(_vm.messageCenterList, function (item) {
    return _c("div", {
      key: _vm.messageCenterTab + item.id,
      staticClass: "message-item",
      on: {
        click: function ($event) {
          return _vm.toDetail(item);
        }
      }
    }, [item.readingStatus === 0 ? _c("span", {
      staticClass: "res-circle"
    }) : _vm._e(), _c("div", {
      staticClass: "message-title",
      attrs: {
        title: item.title
      }
    }, [_c("span", [_vm._v(" " + _vm._s(item.title))])]), _c("div", {
      staticClass: "message-content"
    }, [_vm._v(_vm._s(_vm._f("formatContent")(item.content)))]), _c("div", {
      staticClass: "message-time"
    }, [_vm._v(_vm._s(item.receptionTime))])]);
  }), 0), _vm.messageCenterList.length > 0 ? _c("div", {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "right"
    }
  }, [_c("a-pagination", {
    attrs: {
      pageSize: _vm.pagination.pageSize,
      total: _vm.pagination.total,
      "show-size-changer": "",
      "show-quick-jumper": "",
      "show-less-items": "",
      "show-total": total => _vm.$t("共") + total + _vm.$t("条")
    },
    on: {
      change: _vm.onPageChange,
      showSizeChange: _vm.onShowSizeChange
    },
    model: {
      value: _vm.pagination.current,
      callback: function ($$v) {
        _vm.$set(_vm.pagination, "current", $$v);
      },
      expression: "pagination.current"
    }
  })], 1) : _vm._e(), _c("messageDetailModel", {
    attrs: {
      "message-info": _vm.messageDetailData
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };